module.exports = __webpack_public_path__ + "static/media/FlagBG.18b0fd83.png";